module.exports = __webpack_public_path__ + "static/hkgrotesk-semibold-0e0c69904bd6d66a2578f364ce077b9e.eot";